import { render, staticRenderFns } from "./BatchListContainer.vue?vue&type=template&id=b640cb2c&scoped=true"
import script from "./BatchListContainer.vue?vue&type=script&lang=js"
export * from "./BatchListContainer.vue?vue&type=script&lang=js"
import style0 from "./BatchListContainer.vue?vue&type=style&index=0&id=b640cb2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b640cb2c",
  null
  
)

export default component.exports